import { useTheme } from '@react-navigation/native'
import React from 'react'
import { StyleSheet, Text as TextBase, TextProps as TextBaseProps, TextStyle } from 'react-native'
import { textStyles, StyleKeys } from './style'

export interface TextProps extends TextBaseProps {
  type: StyleKeys
  color?: string
  center?: boolean
  style?: TextStyle | TextStyle[]
}

export const Text = ({ type, center = false, color, style, ...props }: TextProps): React.ReactElement => {
  const theme = useTheme()

  const typeStyles: { [key in TextProps['type']]: TextStyle } = textStyles(theme)
  const flatStyle = style != null ? StyleSheet.flatten(Array.isArray(style) ? style : [style]) : undefined

  const mergedStyles: TextStyle = {
    color: color || theme.colors.black,
    textAlign: center ? 'center' : undefined,
    ...typeStyles[type],
    ...flatStyle,
  }

  return <TextBase style={mergedStyles} {...props} />
}
